// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchLessonsLearnedDataRequest } from '../../../redux/api/apiSlice';
// import {
//   ArrowBack,
//   LocationOn,
//   ExpandMore,
//   ExpandLess,
//   FilterList,
//   WbSunny,
//   Terrain,
//   Public,
//   LocalFireDepartment,
//   Opacity,
//   Cloud,
//   LocationCity
// } from '@mui/icons-material';
// import styles from './LessonsLearnedDetailPage.module.css';

// const HAZARDS = [
//   { name: 'Heatwaves', icon: <WbSunny className={styles.hazardIcon} /> },
//   { name: 'Landslides', icon: <Terrain className={styles.hazardIcon} /> },
//   { name: 'Earthquakes', icon: <Public className={styles.hazardIcon} /> },
//   { name: 'Fires', icon: <LocalFireDepartment className={styles.hazardIcon} /> },
//   { name: 'Floods', icon: <Opacity className={styles.hazardIcon} /> },
//   { name: 'Rainstorms', icon: <Cloud className={styles.hazardIcon} /> },
//   { name: 'Urban Fires', icon: <LocationCity className={styles.hazardIcon} /> },
// ];

// const LessonsLearnedDetailPage = () => {
//   const { id, section } = useParams();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { lessons_learnedData, loading, error } = useSelector((state) => state.api);
//   const [activeSection, setActiveSection] = useState('');
//   const [expandedLabs, setExpandedLabs] = useState({});
//   const [expandedObjectives, setExpandedObjectives] = useState({});
//   const [selectedHazards, setSelectedHazards] = useState([]);
//   const [filterOpen, setFilterOpen] = useState(false);

//   useEffect(() => {
//     dispatch(fetchLessonsLearnedDataRequest());
//   }, [dispatch]);

//   // Find the lesson by name
//   const lesson = lessons_learnedData?.data?.subcategory?.find((l) =>
//     l.name.toLowerCase().replace(/\s+/g, '-') === id
//   );

//   // Set active section based on URL param or default to first section
//   useEffect(() => {
//     if (lesson?.sections?.length) {
//       const sectionTitles = lesson.sections.map(s => s.title.toLowerCase().replace(/\s+/g, '-'));
//       if (section && sectionTitles.includes(section)) {
//         setActiveSection(lesson.sections[sectionTitles.indexOf(section)].title);
//       } else {
//         setActiveSection(lesson.sections[0].title);
//       }
//     }
//   }, [lesson, section]);

//   // When a tab is clicked, update the URL and active section
//   const handleTabClick = (title) => {
//     const slug = title.toLowerCase().replace(/\s+/g, '-');
//     setActiveSection(title);
//     navigate(`/solutions/past-experiences/${id}/${slug}`);
//   };

//   const toggleHazard = (hazard) => {
//     setSelectedHazards(prev =>
//       prev.includes(hazard)
//         ? prev.filter(h => h !== hazard)
//         : [...prev, hazard]
//     );
//   };

//   const allSelected = selectedHazards.length === HAZARDS.length;
//   const toggleSelectAll = () => {
//     setSelectedHazards(allSelected ? [] : HAZARDS.map(h => h.name));
//   };

//   const toggleLabExpansion = (idx) => {
//     setExpandedLabs(prev => ({
//       ...prev,
//       [idx]: !prev[idx]
//     }));
//   };

//   const toggleObjectiveExpansion = (labIdx, objIdx) => {
//     setExpandedObjectives(prev => ({
//       ...prev,
//       [`${labIdx}-${objIdx}`]: !prev[`${labIdx}-${objIdx}`]
//     }));
//   };

//   if (loading) {
//     return <div className={styles.mainContainer}>Loading...</div>;
//   }
//   if (error) {
//     return <div className={styles.mainContainer}>Error: {error}</div>;
//   }
//   if (!lessons_learnedData?.data?.subcategory) {
//     return <div className={styles.mainContainer}>No lesson data available</div>;
//   }
//   if (!lesson) {
//     return <div className={styles.mainContainer}>Lesson not found</div>;
//   }

//   // Filter labs/subsections by selected hazards
//   const filterContent = (subsections) => {
//     if (!selectedHazards.length) return subsections;
//     return subsections.filter(sub => {
//       // Check if subsection has a hazards array
//       if (Array.isArray(sub.hazards) && sub.hazards.length > 0) {
//         return selectedHazards.some(hazard => sub.hazards.includes(hazard));
//       }
//       return false;
//     });
//   };

//   // Section navigation
//   const sections = lesson.sections || [];
//   const activeSectionObj = sections.find(s => s.title === activeSection) || sections[0];
//   const filteredLabs = filterContent(activeSectionObj?.content?.subsections || []);

//   return (
//     <div className={styles.mainContainer}>
//       <button className={styles.backButton} onClick={() => navigate('/solutions/past-experiences')}>
//         <ArrowBack />
//         Back to Past Experiences
//       </button>

//       <div className={styles.headerPaper}>
//         <h1 className={styles.mainTitle}>{lesson.name}</h1>
//         <p className={styles.summary}>{lesson.summary}</p>
//       </div>

//       {/* Collapsible Hazard Filter Card */}
//       <div className={styles.collapsibleCard}>
//         <div className={styles.collapsibleHeader} onClick={() => setFilterOpen(o => !o)}>
//           <div className={styles.collapsibleTitle}>
//             <FilterList className={styles.collapsibleIcon} />
//             Filter by Hazards
//           </div>
//           {filterOpen ? (
//             <ExpandLess className={`${styles.collapseArrow} open`} />
//           ) : (
//             <ExpandMore className={styles.collapseArrow} />
//           )}
//         </div>
//         {filterOpen && (
//           <div className={styles.filterContent}>
//             <div className={styles.hazardList}>
//               <div className={styles.selectAllRow}>
//                 <input
//                   type="checkbox"
//                   className={styles.hazardCheckbox}
//                   checked={allSelected}
//                   onChange={toggleSelectAll}
//                   id="selectAllHazards"
//                 />
//                 <label htmlFor="selectAllHazards" className={styles.hazardLabel}>
//                   Select All Hazards
//                 </label>
//               </div>
//               {HAZARDS.map(hazard => (
//                 <div className={styles.hazardRow} key={hazard.name}>
//                   <input
//                     type="checkbox"
//                     className={styles.hazardCheckbox}
//                     checked={selectedHazards.includes(hazard.name)}
//                     onChange={() => toggleHazard(hazard.name)}
//                     id={`hazard-${hazard.name}`}
//                   />
//                   {hazard.icon}
//                   <label htmlFor={`hazard-${hazard.name}`} className={styles.hazardLabel}>
//                     {hazard.name}
//                   </label>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Section Navigation */}
//       <div className={styles.navigationContainer}>
//         {sections.map((section, idx) => (
//           <button
//             key={section.title}
//             className={`${styles.navButton} ${activeSection === section.title ? styles.active : ''}`}
//             onClick={() => handleTabClick(section.title)}
//           >
//             {section.title}
//           </button>
//         ))}
//       </div>

//       <div className={styles.contentSection}>
//         <div className={styles.card}>
//           <h2 className={styles.mainSectionTitle}>{activeSectionObj?.title}</h2>
//           <div className={styles.cardContent}>
//             {/* Section description (rich text) */}
//             {activeSectionObj?.description && (
//               <div className={styles.sectionDescription} dangerouslySetInnerHTML={{ __html: activeSectionObj.description }} />
//             )}
//             {/* Labs/subsections */}
//             <div className={styles.labsList}>
//               {filteredLabs.length === 0 && (
//                 <div className={styles.noLabsMsg}>No labs match the selected hazards.</div>
//               )}
//               {filteredLabs.map((subsection, subIndex) => (
//                 <div key={subIndex} className={styles.labCard}>
//                   <div className={styles.labHeader} onClick={() => toggleLabExpansion(subIndex)}>
//                     <div className={styles.labHeaderContent}>
//                       <LocationOn className={styles.locationIcon} />
//                       <span className={styles.labTitle}>{subsection.lab}</span>
//                     </div>
//                     {expandedLabs[subIndex] ? (
//                       <ExpandLess className={styles.expandIcon} />
//                     ) : (
//                       <ExpandMore className={styles.expandIcon} />
//                     )}
//                   </div>
//                   {expandedLabs[subIndex] && (
//                     <div className={styles.labContent}>
//                       {subsection.description && (
//                         <div className={styles.labDescription} dangerouslySetInnerHTML={{ __html: subsection.description }} />
//                       )}
//                       {subsection.objectives && (
//                         <div className={styles.objectivesList}>
//                           {subsection.objectives.map((objective, objIndex) => (
//                             <div key={objIndex} className={styles.objectiveItem}>
//                               <h4 className={styles.objectiveTitle}>{objective.option}</h4>
//                               <p className={styles.objectiveDescription}>{objective.description}</p>
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LessonsLearnedDetailPage; 

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLessonsLearnedDataRequest } from '../../../redux/api/apiSlice';
import {
  ArrowBack,
  LocationOn,
  ExpandMore,
  ExpandLess,
  FilterList,
  WbSunny,
  Terrain,
  Public,
  LocalFireDepartment,
  Opacity,
  Cloud,
  LocationCity
} from '@mui/icons-material';

import { Typography } from '@mui/material';
import styles from './LessonsLearnedDetailPage.module.css';
import { useTranslation } from "react-i18next";

const HAZARDS = [
  { name: 'Heatwaves', icon: <WbSunny className={styles.hazardIcon} /> },
  { name: 'Landslides', icon: <Terrain className={styles.hazardIcon} /> },
  { name: 'Earthquakes', icon: <Public className={styles.hazardIcon} /> },
  { name: 'Fires', icon: <LocalFireDepartment className={styles.hazardIcon} /> },
  { name: 'Floods', icon: <Opacity className={styles.hazardIcon} /> },
  { name: 'Rainstorms', icon: <Cloud className={styles.hazardIcon} /> },
  { name: 'Urban Fires', icon: <LocationCity className={styles.hazardIcon} /> },
];

const LessonsLearnedDetailPage = () => {
  const { slug, section } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { lessons_learnedData, loading, error } = useSelector((state) => state.api);

  const { t, i18n } = useTranslation();
  const lang = i18n.language || "en";

  const [activeSection, setActiveSection] = useState('');
  const [expandedLabs, setExpandedLabs] = useState({});
  const [expandedObjectives, setExpandedObjectives] = useState({});
  const [selectedHazards, setSelectedHazards] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);

  /* ----------------------------------
     FETCH DATA (WITH LANG + SLUG)
  ---------------------------------- */
  useEffect(() => {
    if (!slug) return;

    dispatch(
      fetchLessonsLearnedDataRequest({
        lang,
        slug
      })
    );
  }, [dispatch, lang, slug]);

  /* ----------------------------------
     FIND LESSON (BY SLUG, NOT NAME)
  ---------------------------------- */
  const lesson = lessons_learnedData?.data?.subcategory?.[0];

  /* ----------------------------------
     SYNC ACTIVE TAB WITH URL (KEY-BASED)
  ---------------------------------- */
  useEffect(() => {
    if (!lesson?.sections?.length) return;

    const sectionKeys = lesson.sections.map(s => s.key);

    if (section && sectionKeys.includes(section)) {
      setActiveSection(section);
    } else {
      setActiveSection(sectionKeys[0]);
    }
  }, [lesson, section]);

  /* ----------------------------------
     TAB CLICK HANDLER (KEY-BASED)
  ---------------------------------- */
  const handleTabClick = (key) => {
    setActiveSection(key);
    navigate(`/solutions/past-experiences/${slug}/${key}`);
  };

  const toggleHazard = (hazard) => {
    setSelectedHazards(prev =>
      prev.includes(hazard)
        ? prev.filter(h => h !== hazard)
        : [...prev, hazard]
    );
  };

  const allSelected = selectedHazards.length === HAZARDS.length;
  const toggleSelectAll = () => {
    setSelectedHazards(allSelected ? [] : HAZARDS.map(h => h.name));
  };

  const toggleLabExpansion = (idx) => {
    setExpandedLabs(prev => ({
      ...prev,
      [idx]: !prev[idx]
    }));
  };

  if (loading) {
    return <div className={styles.mainContainer}>Loading...</div>;
  }
  if (error) {
    return <div className={styles.mainContainer}>Error: {error}</div>;
  }
  if (!lesson) {
    return <div className={styles.mainContainer}>Lesson not found</div>;
  }

  /* ----------------------------------
     FILTER LABS BY HAZARDS
  ---------------------------------- */
  const filterContent = (subsections) => {
    if (!selectedHazards.length) return subsections;
    return subsections.filter(sub =>
      Array.isArray(sub.hazards) &&
      sub.hazards.some(h => selectedHazards.includes(h))
    );
  };

  const sections = lesson.sections.reduce((acc, s) => {
    acc[s.key] = s;
    return acc;
  }, {});

  const activeSectionObj = sections[activeSection];
  const filteredLabs = filterContent(activeSectionObj?.content?.subsections || []);

  return (
    <div className={styles.mainContainer}>
      <button
        className={styles.backButton}
        onClick={() => navigate('/solutions/past-experiences')}
      >
        <ArrowBack />
        {t("solutions.navigation.backToPages.pastExperiences")}
      </button>

      <div className={styles.headerPaper}>
        <Typography variant="h6" className={styles.mainTitle}>
          {lesson.name}
        </Typography>
        <Typography variant="body1" className={styles.summary}>
          {lesson.summary}
        </Typography>
      </div>

      {/* FILTER */}
      <div className={styles.collapsibleCard}>
        <div
          className={styles.collapsibleHeader}
          onClick={() => setFilterOpen(o => !o)}
        >
          <div className={styles.collapsibleTitle}>
            <FilterList className={styles.collapsibleIcon} />
            <Typography variant="subtitle1" className={styles.collapsibleTitle}>
              Filter by Hazards
            </Typography>
          </div>
          {filterOpen ? <ExpandLess /> : <ExpandMore />}
        </div>

        {filterOpen && (
          <div className={styles.filterContent}>
            <div className={styles.selectAllRow}>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={toggleSelectAll}
              />
              Select All Hazards
            </div>

            {HAZARDS.map(h => (
              <div key={h.name} className={styles.hazardRow}>
                <input
                  type="checkbox"
                  checked={selectedHazards.includes(h.name)}
                  onChange={() => toggleHazard(h.name)}
                />
                {h.icon}
                <Typography variant="subtitle1">{h.name}</Typography>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* TABS */}
      <div className={styles.navigationContainer}>
        {lesson.sections.map(s => (
          <button
            key={s.key}
            className={`${styles.navButton} ${activeSection === s.key ? styles.active : ''
              }`}
            onClick={() => handleTabClick(s.key)}
          >
            <Typography
              variant="body1"
              noWrap
              sx={{ minWidth: 0 }}
            >
              {s.title}
            </Typography>
          </button>
        ))}
      </div>

      {/* CONTENT */}
      <div className={styles.card}>
        <Typography variant="h6" className={styles.mainSectionTitle}>
          {activeSectionObj?.title}
        </Typography>

        <div className={styles.cardContent}>
          <div className={styles.labsList}>
            {filteredLabs.map((sub, idx) => (
              <div key={idx} className={styles.labCard}>
                <div className={styles.labHeader}
                  onClick={() => toggleLabExpansion(idx)}>
                  <div className={styles.labHeaderContent}>
                    <LocationOn className={styles.locationIcon} />
                    <Typography variant="h6" className={styles.labTitle}>
                      {sub.lab}
                    </Typography>
                  </div>

                  {expandedLabs[idx] ? (
                    <ExpandLess className={styles.expandIcon} />
                  ) : (
                    <ExpandMore className={styles.expandIcon} />
                  )}
                </div>


                {expandedLabs[idx] && (
                  <div className={styles.labContent}>
                    <Typography variant="body1" className={styles.objectiveDescription}>
                      {sub.description}
                    </Typography>
                    {/* <div className={styles.objectiveDescription}
                      dangerouslySetInnerHTML={{ __html: sub.description }}
                    /> */}

                    {sub.objectives?.map((o, i) => (
                      <div key={i}>
                        <Typography variant="h6" className={styles.labTitle}>
                          {o.option}
                        </Typography>

                        <Typography variant="body1">
                          {o.description}
                        </Typography>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LessonsLearnedDetailPage;
